import { render, staticRenderFns } from "./EvrakGonderIslemDetayView.vue?vue&type=template&id=9b78817e&scoped=true"
import script from "./EvrakGonderIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./EvrakGonderIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b78817e",
  null
  
)

export default component.exports